/*
 * File: PatientHomeRoutes.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Routes used by link buttons on patient home page
 */
import React from "react";
import Work from "@material-ui/icons/Work";
import PersonIcon from "@material-ui/icons/Person";
import AssignmentInd from "@material-ui/icons/AssignmentInd";
import DateRangeIcon from "@material-ui/icons/DateRange";
import SupervisorAccount from "@material-ui/icons/SupervisorAccount";
import CreditCard from "@material-ui/icons/CreditCard";

const PatientHomeRoutes = [
  {
    path: "demographics",
    icon: <PersonIcon />,
    title: "Demographics"
  },
  {
    path: "insurance_and_guarantors",
    icon: <Work />,
    title: "Insurance & Guarantors"
  },
  {
    path: "clinical",
    icon: <AssignmentInd />,
    title: "Clinical"
  },
  {
    path: "appointments",
    icon: <DateRangeIcon />,
    title: "Appointments & Follow-Ups"
  },
  {
    path: "referrals",
    icon: <SupervisorAccount />,
    title: "Referrals"
  },
  {
    path: "new_charge",
    icon: <CreditCard />,
    title: "Billing Order"
  }
];

export default PatientHomeRoutes;
